import { Box, Button, ButtonDropdown, FormField, Header, Input, Modal, Popover, Select, SelectProps, SpaceBetween, SplitPanel, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiPirate, mdiRefresh, mdiSwapHorizontal, mdiSwapHorizontalBold } from '@mdi/js';
import Icon from '@mdi/react';
import { addDays, format, parse } from 'date-fns';
import { es } from 'date-fns/locale/es';
import DPModal from '../../../../components/DPModal';
import BadgeCustom from '../../../../components/extras/BadgeCustom';
import ConfirmDelete from '../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../components/extras/Favorites';
import SelectUser from '../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemDirector, ItemShift, ItemShift2 } from '../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatPhone, getCookie, getParameter, getUrlVersion, getUser, setData, setLoading } from '../../../commons/functions';
import { useGlobalState } from '../../../context/GlobalStateContext';
const pageSize = 20;
type OptionDefinition = SelectProps.Option;

export const MasterShiftsPage = () => {
    const { data, menu, parameters, idUser } = useGlobalState();
    const [showNew, setShowNew] = useState(false);
    const [isSplitPanelOpen, setIsSplitPanelOpen] = useState(false);
    const [viewPast, setViewPast] = useState(false);
    const [expanded, setExpanded] = useState<boolean[]>([true, false, false]);

    const [targetIdUser, setTargetIdUser] = useState(0);
    const [targetShift, setTargetShift] = useState('');

    //const [filteredShifts, setFilteredShifts] = useState<ItemShift2[]>([]);
    const [exchangeTowSource, setExchangeTowSource] = useState<any>();
    const [exchangeDirectorSource, setExchangeDirectorSource] = useState<any>();
    const [exchangeDirectorTarget, setExchangeDirectorTarget] = useState<any>();
    const [exchangeTowTarget, setExchangeTowTarget] = useState<any>();
    const [keyw, setKeyw] = useState<string>("");
    const [date, setDate] = useState<string>("");

    //const storeAdmin = useStoreAdmin();



    const [usersTows, setUsersTows] = useState<ItemDirector[]>([]);
    const [usersDirectors, setUsersDirectors] = useState<ItemDirector[]>([]);
    const [shifts, setShifts] = useState<ItemShift2[]>([]);
    const [shiftsMaster, setShiftsMaster] = useState<[]>([]);
    const [shift, setShift] = useState<ItemShift>();
    const [shiftSell, setShiftSell] = useState<ItemShift2>();
    const [newShift, setNewShift] = useState<any[]>([]);
    const [selectedTarget, setSelectedTarget] = useState<OptionDefinition | null>(null);

    const [filteringText, setFilteringText] = useState('');
    const [sortingColumn, setSortingColumn] = useState({
        sortingField: 'registration',
        isDescending: false,
    });

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    //const [loading, setLoading] = useState<boolean>(true);

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [init, setInit] = useState(false);


    const expa = [true, false, false];
    const returnURL = getParameter(window.location.hash, 'returnURL');

    useEffect(() => {
        if (init) {
            (returnURL && returnURL === '' ? window.location.hash = '#home' : window.location.hash = returnURL);

        };

    }, [init]);
    const handleExchange = async () => {

        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/shifts/exchange',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    shiftSource: exchangeTowTarget ? exchangeTowSource : exchangeDirectorSource,
                    shiftTarget: exchangeTowTarget ? exchangeTowTarget : exchangeDirectorTarget,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.code === 0) {
                setExchangeTowSource(undefined);
                setExchangeTowTarget(undefined);
                setExchangeDirectorSource(undefined);
                setExchangeDirectorTarget(undefined);
                handleRefresh();
                addNotification(data.status, "success", setData)

            } else {
                addNotification(data.status, "error", setData)
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetShift = async (date: string) => {
        try {
            setLoading(true);

            let body: any = {
                start: format(addDays(new Date(), -1), 'dd-MM-yyyy'),
                orderBy: "dateShift",
                order: "asc",
            }
            if (viewPast) {
                body.start = format(addDays(new Date(), -60), 'dd-MM-yyyy')
                body.end = format(addDays(new Date(), 0), 'dd-MM-yyyy')
            }

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/shift',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ date: date })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.shift) {
                const ss: any[] = data.shift
                const shiftTypes = ["DIR", "AM", "PM"];

                let shs = shiftTypes.map(type => {
                    const found = ss.find(s => s.shift === type);
                    return {
                        shift: type,
                        dateShift: date,
                        idUser: found?.idUser ?? 0,
                        idShift: found?.idShift ?? 0
                    };
                });
                setNewShift(shs)

            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleAddNewShift = async () => {
        try {
            setLoading(true);

            let body: any = {
                new: newShift,
                start: format(addDays(new Date(), -1), 'dd-MM-yyyy'),
                orderBy: "dateShift",
                order: "asc",
            }

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/addnew',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data) {
                addNotification(data.status, data.code === 0 ? "success" : "error", setData);
                setShowNew(false);
                setTimeout(() => handleRefresh(), 50)

            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleRefresh = async () => {
        try {
            setLoading(true);

            let body: any = {
                start: format(addDays(new Date(), -1), 'dd-MM-yyyy'),
                orderBy: "dateShift",
                order: "asc",
            }
            if (viewPast) {
                body.start = format(addDays(new Date(), -60), 'dd-MM-yyyy')
                body.end = format(addDays(new Date(), 0), 'dd-MM-yyyy')
            }

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.shifts) {

                setShiftsMaster(data.shifts)
                setShifts(pivotShifts(data.shifts))



            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };


    const pivotShifts = (data: any[]): ItemShift2[] => {
        const grouped = data.reduce((acc: any, item: any) => {
            const date = item.dateShift;

            // Initialize the date group if it doesn't exist
            if (!acc[date]) {
                acc[date] = {
                    dateShift: date,
                    idShift: item.idShift,
                    isSelling: item.isSelling,
                    isToday: item.isToday,
                    isPast: item.isPast,
                    isFuture: item.isFuture,
                    AM: null,
                    PM: null,
                    DIR: null
                };
            }
            if (acc[date].hasOwnProperty(item.shift)) {
                acc[date][item.shift] = item;
            }

            return acc;
        }, {});
        return Object.values(grouped);
    };

    useEffect(() => {
        handleRefresh();
    }, [viewPast]);

    const filteredShifts = keyw.length >= 3
        ? shifts
            .filter(shift => {
                const searchWords = keyw.toLowerCase().split(/\s+/).filter(Boolean);


                // Helper function to normalize strings: remove accents and non-alphanumeric chars
                const normalize = (str: string | undefined | null) =>
                    (str || "")
                        .toString()
                        .toLowerCase()
                        .normalize("NFD") // Decomposes accented characters (e.g., 'í' -> 'i' + '◌́')
                        .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
                        .replace(/[^a-z0-9]/g, ""); // Removes non-alphanumeric



                return searchWords.every(word =>
                    normalize(shift.dateShift.toLowerCase()).includes(normalize(word)) ||
                    normalize(shift.DIR?.user.toLowerCase()).includes(normalize(word)) ||
                    normalize(shift.AM?.user.toLowerCase()).includes(normalize(word)) ||
                    normalize(shift.PM?.user.toLowerCase()).includes(normalize(word))
                );
            })
        : shifts;


    const handleSellShift = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/mercenaries/shifts/sell',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idShift: shiftSell.DIR.idShift,
                    start: format(addDays(new Date(), -1), 'dd-MM-yyyy'),
                    orderBy: "dateShift",
                    order: "asc",
                    jsonExchange: true
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.shifts) {
                handleRefresh();
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            splitPanelOpen={isSplitPanelOpen}
            onSplitPanelToggle={({ detail }) => setIsSplitPanelOpen(detail.open)}

            splitPanel={
                <SplitPanel hidePreferencesButton header={`Turno #${shift?.idShift}`} closeBehavior='hide'
                >test
                </SplitPanel >
            }
            content={
                < SpaceBetween size="xs" >
                    <Header actions={


                        <SpaceBetween direction="horizontal" size="xs">
                            <Button
                                variant='primary'
                                key={"btnAdd"}
                                onClick={() => {
                                    setDate("");
                                    setShowNew(true)
                                }}
                            >Agregar</Button>
                            <Favorites />
                        </SpaceBetween>
                    }>
                        Turnos { }

                    </Header>
                    <Table

                        stripedRows
                        stickyHeader
                        variant='embedded'
                        cellVerticalAlign="top"
                        filter={
                            <SpaceBetween direction='horizontal' size='xs'>
                                <Input value={keyw} placeholder='Filtar' onChange={({ detail }) => {
                                    setKeyw(detail.value);
                                }} />

                                {!viewPast ? <Button onClick={() => setViewPast(!viewPast)} >Ver pasados</Button> : <Button onClick={() => setViewPast(!viewPast)} >Ver actuales</Button>}


                                <Button
                                    style={{ root: btnIconForm }}
                                    key={"btnDate"}
                                    onClick={() => {
                                        if (parameters.date !== "") {
                                            setCurrentPageIndex(1);
                                            handleRefresh();
                                        }
                                    }}
                                ><Icon path={mdiRefresh} size={1} /></Button>
                            </SpaceBetween>
                        }
                        //onRowClick={({ detail }) => handleRowClick(detail.item)}
                        columnDefinitions={[
                            {
                                id: "dateShift",
                                header: "Fecha",
                                width: 120,
                                cell: (item) => (
                                    <FormField
                                        constraintText={`${(() => {
                                            const str = format(parse(item.dateShift, 'dd-MM-yyyy', new Date()), 'EEEE', { locale: es });
                                            return str.charAt(0).toUpperCase() + str.slice(1);
                                        })()}`}
                                        label={`${item.dateShift}`}
                                    >

                                        {item?.DIR?.isSelling == 1 && <BadgeCustom color="lime" >En venta</BadgeCustom>}
                                        {item?.DIR?.isSelling == 2 && <BadgeCustom color="violet" >Vendido</BadgeCustom>}
                                        {item?.DIR?.isSelling == 3 && <BadgeCustom color="blue" >Pagado</BadgeCustom>}
                                    </FormField>
                                )
                            },
                            {
                                id: "userDirector",
                                header: "Director",
                                cell: (item) =>
                                    item.DIR && (
                                        <FormField
                                            constraintText={
                                                item.DIR.userOld != ""
                                                    ? <>
                                                        <Icon path={mdiSwapHorizontal} size={1} /> {item.DIR.userOld}
                                                    </>
                                                    : null
                                            }
                                            label={item.isToday ? <Popover triggerType="custom" dismissButton={false} header='Contacto' content={formatPhone(getUser(item.DIR.idUser, data)?.phone1)}><strong>

                                                {item.DIR.user}</strong></Popover> : item.DIR.userMercenary !== "" ? <><Icon path={mdiPirate} size={0.75} /> {item.DIR.userMercenary}</> : item.DIR.user

                                            }
                                        >
                                            {item.DIR.idUserMercenary !== 0 ? <>
                                                {item.DIR.user}
                                            </> : ""}
                                        </FormField>
                                    )

                                //sortingField: "displayName",
                            },
                            {
                                id: "userTow1",
                                header: "Remolcador AM",
                                cell: (item) =>
                                    item.AM && (
                                        <FormField
                                            constraintText={
                                                item.AM.userOld !== ""
                                                    ? <>
                                                        <Icon path={mdiSwapHorizontal} size={1} /> {item.AM.userOld}
                                                    </>
                                                    : null
                                            }
                                            label={item.AM.user}
                                        />
                                    )

                                //sortingField: "displayName",
                            },
                            {
                                id: "userTow2",
                                header: "Remolcador PM",
                                cell: (item) =>
                                    item.PM && (
                                        <FormField
                                            constraintText={
                                                item.PM.userOld !== ""
                                                    ? <>
                                                        <Icon path={mdiSwapHorizontal} size={1} /> {item.PM.userOld}
                                                    </>
                                                    : null
                                            }
                                            label={item.PM.user}
                                        />
                                    )

                                //sortingField: "displayName",
                            },
                            {
                                id: "action",
                                header: "",
                                cell: (item) =>
                                    <ButtonDropdown
                                        onItemClick={(e) => {
                                            console.log(e.detail.id)
                                            if (e.detail.id === "edit") {
                                                setDate(item.dateShift)
                                                handleGetShift(item.dateShift)
                                                setShowNew(true)
                                            }
                                            else if (e.detail.id === "sellDIR") {
                                                setShiftSell(item)

                                            }
                                            else if (e.detail.id === "exchangeDIR") {
                                                setExchangeDirectorTarget(undefined);
                                                //setExchangeDirectorSource(shifts.find((s: any) => item.idShift == s.idShift))
                                                setExchangeDirectorSource(item?.DIR)
                                            }
                                            else if (e.detail.id === "exchangeAM") {

                                                setExchangeTowTarget(undefined);
                                                setExchangeTowSource(item.AM)
                                            }
                                            else if (e.detail.id === "exchangePM") {
                                                setExchangeTowTarget(undefined);
                                                setExchangeTowSource(item.PM)
                                            }
                                        }}
                                        expandToViewport
                                        items={[
                                            { id: "edit", text: "Editar turno" },
                                            ...(item?.DIR?.idUser > 0 ? [{
                                                text: "Director",
                                                items: [
                                                    {
                                                        id: "exchangeDIR", text: "Intercambiar director",
                                                        disabled: (!item.DIR || item.DIR?.idUser === 0) || item?.DIR?.userMercenary !== "" || item.isFuture !== 1,
                                                        disabledReason: item?.DIR?.userMercenary !== "" ? "No se puede intercambiar un turno con director mercenario" : item.isFuture !== 1 ? "Solo se pueden intercambiar los turnos futuros" : ""
                                                    },
                                                    {
                                                        id: "sellDIR", text: "Venta mercenario",

                                                        disabled: (!item.DIR || item.DIR?.idUser === 0 || item.DIR?.isSelling !== 0),
                                                        disabledReason: item.DIR?.isSelling !== 0 ? "El turno ya está en venta o vendido" : ""
                                                    },
                                                ]

                                            }] : []),

                                            ...(item?.AM?.idUser > 0 ? [{
                                                id: "exchangeAM", text: "Intercambiar remolcador AM", disabled: !item.AM || item.AM?.idUser === 0,
                                            }] : []),
                                            ...(item?.PM?.idUser > 0 ? [{
                                                id: "exchangePM", text: "Intercambiar remolcador PM", disabled: !item.PM || item.PM?.idUser === 0,
                                            }] : []),

                                        ]}
                                        variant="icon"
                                    />
                            },
                        ]}
                        items={filteredShifts}
                        selectionType={undefined}
                        trackBy="idShift"
                    />

                    <ConfirmDelete

                        subtitle={`El turno solo puede ser puesto a la venta hasta el ${shiftSell?.dateShift} a las 23:00 hrs.`}
                        header={`Vender turno ${shiftSell?.dateShift} - ${shiftSell?.DIR.user}`} show={shiftSell !== undefined}
                        onDismiss={() => setShiftSell(undefined)}
                        onConfirm={async () => {
                            handleSellShift()
                        }} confirmWord={'vender'} action={'Poner a la venta'} warning={'Una vez que el turno ha sido puesto en venta, este no puede ser cancelado ni retractado.'}

                    />

                    <Modal header="Agregar turno" visible={showNew} onDismiss={() => setShowNew(false)}
                        footer={
                            <Box>
                                <Box float='left'><Button variant="link" onClick={() => setShowNew(false)}>Cancelar</Button></Box>
                                <Box float='right'>
                                    <Button variant="primary"
                                        disabled={date === "" /* || newShift.every((s: any) => s.idUser === 0)*/}
                                        onClick={async () => {
                                            handleAddNewShift()
                                        }}>Guardar</Button>

                                </Box>

                            </Box>}
                    >
                        <SpaceBetween direction='vertical' size='xs'>
                            <FormField label="Fecha del turno">
                                <DPModal
                                    start={new Date()}
                                    date={date}
                                    disabledDates={filteredShifts.map(shift => shift.dateShift)}
                                    onConfirm={(date) => {
                                        setDate(date)
                                        handleGetShift(date)
                                    }}
                                />
                            </FormField>
                            {date !== "" && newShift.length > 0 && (
                                <SpaceBetween direction='vertical' size='l'>
                                    <FormField label="Director">
                                        <SelectUser
                                            value={newShift.find((s: any) => s.shift === "DIR").idUser ?? 0}
                                            onConfirm={(user) => {
                                                const u = user ? user.idUser : 0
                                                const updatedShifts = newShift.map((s: any) => {
                                                    if (s.shift === "DIR")
                                                        return { ...s, idUser: u };
                                                    return s;
                                                });
                                                setNewShift(updatedShifts);
                                            }}
                                        />
                                    </FormField>
                                    <FormField label="Remolcador AM">
                                        <SelectUser
                                            value={newShift.find((s: any) => s.shift === "AM").idUser ?? 0}
                                            onConfirm={(user) => {
                                                const u = user ? user.idUser : 0
                                                const updatedShifts = newShift.map((s: any) => {
                                                    if (s.shift === "AM")
                                                        return { ...s, idUser: u };
                                                    return s;
                                                });
                                                setNewShift(updatedShifts);

                                            }}
                                        />
                                    </FormField>
                                    <FormField label="Remolcador PM">
                                        <SelectUser
                                            value={newShift.find((s: any) => s.shift === "PM").idUser ?? 0}
                                            onConfirm={(user) => {
                                                const u = user ? user.idUser : 0
                                                const updatedShifts = newShift.map((s: any) => {
                                                    if (s.shift === "PM")
                                                        return { ...s, idUser: u };
                                                    return s;
                                                });
                                                setNewShift(updatedShifts);
                                            }}
                                        />
                                    </FormField>
                                </SpaceBetween>

                            )}
                        </SpaceBetween>
                    </Modal>
                    {exchangeTowSource && (
                        <Modal size='medium' visible={!!exchangeTowSource} onDismiss={() => setExchangeTowSource(undefined)}
                            header={"Intercambiar turno"}
                            footer={
                                <Box>
                                    <Box float="left"><Button variant="link" onClick={() => setExchangeTowSource(undefined)}>Cancelar</Button> </Box>
                                    <Box float="right">

                                        <Button variant='primary' disabled={!exchangeTowTarget} onClick={() => {
                                            handleExchange()
                                            //TODO
                                        }}>Intercambiar</Button>
                                    </Box>
                                </Box>
                            }
                        >
                            Intercambiar el turno <strong>{exchangeTowSource.shift}</strong> de <strong>{exchangeTowSource.user}</strong> del <strong>{exchangeTowSource.dateShift}</strong>
                            <SpaceBetween direction='vertical' size='xs'>
                                <Select selectedOption={exchangeTowTarget}
                                    onChange={(event) => {
                                        const option = event.detail.selectedOption as any;
                                        setExchangeTowTarget(event.detail.selectedOption);

                                    }}
                                    options={shiftsMaster.filter((s1: any) => (s1.shift === "AM" || s1.shift === "PM") && s1.idShift !== exchangeTowSource.idShift)
                                        .map((s: any) => {
                                            const isSameUser = s.idUser === exchangeTowSource.idUser;
                                            const isFuture = s.isFuture === 1;
                                            let disabled = false;
                                            var disabledReason = "";

                                            // 1. Check if it's the same user

                                            // 2. Check if the shift already has its own exchange
                                            const hasOwnExchange = s.jsonExchange && Object.keys(s.jsonExchange).length > 0;


                                            const isAlreadyTarget = shiftsMaster.filter((s1: any) => (s1.shift === "AM" || s1.shift === "PM"))
                                                .some((ts: any) => {
                                                    const ex = ts.jsonExchange;
                                                    if (!ex || Object.keys(ex).length === 0) return false;

                                                    const isTargetClose = ex.target?.idShift === s.idShift;
                                                    const isTargetOpen = Array.isArray(ex.targets) &&
                                                        ex.targets.some((t: any) => t.idShift === s.idShift);
                                                    return isTargetClose || isTargetOpen;
                                                });



                                            if (isSameUser) {
                                                disabled = true;
                                                disabledReason = "1.- No puedes intercambiar el turno con si mismo.";
                                            } else if (hasOwnExchange) {
                                                disabled = true;
                                                disabledReason = "2.- Este turno ya tiene un enroque en curso.";
                                            } else if (isAlreadyTarget) {
                                                disabled = true;
                                                disabledReason = "3.- Este turno tiene un enroque pendiente.";
                                            }
                                            return {
                                                ...s,
                                                value: s.idShift.toString(),
                                                label: `${s.dateShift}-${s.shift} - ${s.user}`,
                                                description: disabledReason, // Cloudscape displays this below the label
                                                disabled: disabled,
                                            };
                                        })}
                                />
                                <SpaceBetween direction='horizontal' size='xs'>
                                    <FormField label={exchangeTowSource.user}>
                                        {exchangeTowSource.dateShift} {exchangeTowSource.shift}
                                    </FormField>
                                    <Box fontSize="body-m"><Icon path={mdiSwapHorizontalBold} size={2} /></Box>
                                    {exchangeTowTarget && (
                                        <FormField label={exchangeTowTarget.user ?? "???"}>
                                            {exchangeTowTarget.dateShift ?? "-------------"} {exchangeTowTarget.shift ?? ""}
                                        </FormField>
                                    )}


                                </SpaceBetween>
                            </SpaceBetween>
                        </Modal>
                    )}

                    {exchangeDirectorSource && (
                        <Modal size='medium' visible={!!exchangeDirectorSource} onDismiss={() => setExchangeDirectorSource(undefined)}
                            header={"Intercambiar turno"}
                            footer={
                                <Box>
                                    <Box float="left"><Button variant="link" onClick={() => setExchangeDirectorSource(undefined)}>Cancelar</Button> </Box>
                                    <Box float="right">

                                        <Button variant='primary' disabled={!exchangeDirectorTarget} onClick={() => {
                                            handleExchange()
                                            //TODO
                                        }}>Intercambiar</Button>
                                    </Box>
                                </Box>
                            }
                        >
                            Intercambiar el director turno <strong>{exchangeDirectorSource.user}</strong> del <strong>{exchangeDirectorSource.dateShift}</strong>

                            <Select selectedOption={exchangeDirectorTarget}
                                onChange={(event) => {
                                    const option = event.detail.selectedOption as any;
                                    setExchangeDirectorTarget(event.detail.selectedOption);
                                    console.log(event.detail.selectedOption)

                                }}
                                options={shifts.filter((s1: any) => s1.DIR)
                                    .map((s: any) => {
                                        const s2 = s.DIR;
                                        const isSameUser = s2.idUser === exchangeDirectorSource.idUser;
                                        const isFuture = s2.isFuture === 1;
                                        let disabled = false;
                                        var disabledReason = "";

                                        if (isSameUser) {
                                            disabled = true;
                                            disabledReason = "1.- No puedes intercambiar el turno con si mismo.";
                                        } else if (!isFuture) {
                                            disabled = true;
                                            disabledReason = "2.- Este turno ya fue ejecutado.";
                                        } else if (s2.idUserMercenary !== 0) {
                                            disabled = true;
                                            disabledReason = "3.- No se puede intercambiar con un mercenario.";
                                        }

                                        return {
                                            ...s2,
                                            value: s2.idShift.toString(),
                                            label: `${s.dateShift}-${s2.shift} - ${s2.user}`,
                                            description: disabledReason, // Cloudscape displays this below the label
                                            disabled: disabled,
                                            // Keep your metadata
                                        };
                                    })}
                            />
                        </Modal>
                    )}
                </SpaceBetween >
            }
        />

    );
};
